export const AUTH_TOKEN_KEY = "Auth Token";
export const TENANT_KEY = "Tenant";
